import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["style"],
    _excluded2 = ["style"],
    _excluded3 = ["style"],
    _excluded4 = ["style"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
/* eslint-disable react/prop-types */

export function renderViewDefault(props) {
  return /*#__PURE__*/React.createElement("div", props);
}
export function renderTrackHorizontalDefault(_ref) {
  var style = _ref.style,
      props = _objectWithoutProperties(_ref, _excluded);

  var finalStyle = _objectSpread(_objectSpread({}, style), {}, {
    right: 2,
    bottom: 2,
    left: 2,
    borderRadius: 3
  });

  return /*#__PURE__*/React.createElement("div", _extends({
    style: finalStyle
  }, props));
}
export function renderTrackVerticalDefault(_ref2) {
  var style = _ref2.style,
      props = _objectWithoutProperties(_ref2, _excluded2);

  var finalStyle = _objectSpread(_objectSpread({}, style), {}, {
    right: 2,
    bottom: 2,
    top: 2,
    borderRadius: 3
  });

  return /*#__PURE__*/React.createElement("div", _extends({
    style: finalStyle
  }, props));
}
export function renderThumbHorizontalDefault(_ref3) {
  var style = _ref3.style,
      props = _objectWithoutProperties(_ref3, _excluded3);

  var finalStyle = _objectSpread(_objectSpread({}, style), {}, {
    cursor: 'pointer',
    borderRadius: 'inherit',
    backgroundColor: 'rgba(0,0,0,.2)'
  });

  return /*#__PURE__*/React.createElement("div", _extends({
    style: finalStyle
  }, props));
}
export function renderThumbVerticalDefault(_ref4) {
  var style = _ref4.style,
      props = _objectWithoutProperties(_ref4, _excluded4);

  var finalStyle = _objectSpread(_objectSpread({}, style), {}, {
    cursor: 'pointer',
    borderRadius: 'inherit',
    backgroundColor: 'rgba(0,0,0,.2)'
  });

  return /*#__PURE__*/React.createElement("div", _extends({
    style: finalStyle
  }, props));
}